import React from "react";
import AdminUsersPanel from "@/components/admin/AdminUsersPanel";

export default function AdminUsers() {
  return (
    <div data-testid="admin-users-page">
      <AdminUsersPanel />
    </div>
  );
}
